import { execute_generator } from './networking/index'
import axios from 'axios'

const user_env = process.env.VUE_APP_API_USER_URL
const client = axios.create({
    baseURL: user_env,
    json: true
})

export default {
    async execute (method, resource, data) {
        let accessToken = localStorage.getItem('jwt');
        return client({
            method,
            url: resource,
            data,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then(req => {
            return req.data
        })
    },
    getUsers () {
        return this.execute('get', '/users/all')
    },
    getUser (id) {
        return this.execute('get', `/users/${id}`)
    },
    getUsersByAccount (accountId) {
        return this.execute('get', `/users/byacct/${accountId}`)
    },
    createUser (data) {
        return this.execute('post', '/users/create', data)
    },
    updateUser (id, data) {
        return this.execute('put', `/users/${id}`, data)
    },
    deleteUser (id) {
        return this.execute('delete', `/users/${id}`)
    },
    searchUsers: (payload) => execute_generator('post', {service:user_env, resource:'/users/search'}, payload)
}
